import React from 'react';
import { CheckIcon, CreditCardIcon, LockIcon, ZapIcon } from 'lucide-react';
import { PRICE, REGULAR_PRICE, SAVINGS, TOTAL_VALUE, valueStack } from '../data/valueStack';
import { CtaButton } from './CtaButton';
const included = ['50 ready-to-play jazz exercises', 'Complete theory section', '6 complete teaching volumes', '6 free bonus gifts', 'Beginner through advanced', 'Lifetime access to all materials'];
export function Offer() {
  return <section id="offer" aria-labelledby="offer-heading" className="scroll-mt-6 bg-night py-14 sm:py-20" data-id="element-219" data-mp="u0odmv1ed67u">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-220" data-mp="p24qirb2hodw">
        <div className="relative" data-id="element-221" data-mp="13xsohypslf9c">
          <span className="absolute -top-3.5 left-1/2 z-10 -translate-x-1/2 whitespace-nowrap rounded-full bg-amber px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-night sm:text-xs" data-id="element-222" data-mp="13uoegkpnbpar">
            Launch offer &middot; 96% off
          </span>

          <div className="overflow-hidden rounded-2xl border border-amber/50 bg-night-800" data-id="element-223" data-mp="2acbkoxsy5139">
            <div className="border-b border-night-600 bg-night-900 px-5 pb-8 pt-10 text-center sm:px-10 sm:pb-10 sm:pt-12" data-id="element-224" data-mp="pj5uqoeuwie0">
              <h2 id="offer-heading" className="font-display text-3xl leading-[0.98] text-cream sm:text-5xl" data-id="element-225" data-mp="uhh30upi6ku4">
                Jazz Teacher&rsquo;s Arsenal&trade;{' '}
                <span className="block text-amber" data-id="element-226" data-mp="13hnnj0jmcl2s">Complete Package</span>
              </h2>
              <p className="mt-4 font-serif text-lg italic text-cream-soft" data-id="element-227" data-mp="6rmqyfd0d0ax">
                Theory + 50 ready-to-play jazz exercises &middot; 6 Volumes + 6 Bonuses
              </p>
            </div>

            <div className="px-5 py-8 sm:px-10 sm:py-10" data-id="element-228" data-mp="fsb6jei1v8px">
              <img src="https://cdn.magicpatterns.com/uploads/vFchDyybp1gA7zUWkdrNdP/ChatGPT_Image_25_ago_2026,_12_38_39_p.m..png" alt="Everything included in the Jazz Teacher's Arsenal package" className="mx-auto w-full max-w-xl rounded-xl" data-id="element-229" data-mp="km5voxgfcfwe" />

              <div className="mt-8 border-t border-night-600 pt-8" data-id="element-230" data-mp="vefta29km513">
                <p className="text-center text-[11px] font-semibold uppercase tracking-label text-amber" data-id="element-231" data-mp="qh5v9y848l1n">
                  What&rsquo;s included
                </p>
                <ul className="mt-6 grid gap-4 sm:grid-cols-2 sm:gap-x-8" data-id="element-232" data-mp="157d4dnc8grpo">
                  {included.map(item => <li key={item} className="flex items-start gap-3" data-id="element-233" data-mp="cgmpkxr4hr2n">
                      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-amber-deep" aria-hidden="true" data-id="element-234" data-mp="ciz7jawvs1fp">
                        <CheckIcon className="h-3.5 w-3.5 text-amber" data-id="element-235" data-mp="hfzb9f69cs3n" />
                      </span>
                      <span className="text-sm font-semibold leading-snug text-cream sm:text-base" data-id="element-236" data-mp="1wwpz0rt2ub8j">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>

              <div className="mt-8 border-t border-night-600 pt-8" data-id="element-237" data-mp="20dm8wedfj899">
                <p className="text-center text-[11px] font-semibold uppercase tracking-label text-cream-muted" data-id="element-238" data-mp="25dgtk06m31lv">
                  Where the value comes from
                </p>
                <dl className="mx-auto mt-5 max-w-sm" data-id="element-239" data-mp="1qiu8l2sgq7as">
                  {valueStack.map(line => <div key={line.label} className="flex items-baseline justify-between gap-4 border-b border-night-600 py-2.5" data-id="element-240" data-mp="2j556g5oopu3w">
                      <dt className="text-sm text-cream-soft" data-id="element-241" data-mp="2o62rcq12x293">{line.label}</dt>
                      <dd className="text-sm font-semibold tabular-nums text-cream" data-id="element-242" data-mp="29f277nqyzjx4">{line.value}</dd>
                    </div>)}
                  <div className="flex items-baseline justify-between gap-4 py-3" data-id="element-243" data-mp="323hgrurc1a12">
                    <dt className="text-xs font-semibold uppercase tracking-label text-cream-muted" data-id="element-244" data-mp="36ug0737mao8j">
                      Total real value
                    </dt>
                    <dd className="text-sm font-semibold tabular-nums text-cream-muted line-through" data-id="element-245" data-mp="1j7pl4uka2it3">
                      {TOTAL_VALUE}
                    </dd>
                  </div>
                </dl>
              </div>

              <div className="mt-6 border-t border-night-600 pt-8 text-center" data-id="element-246" data-mp="1495astsyk0po">
                <p className="flex items-baseline justify-center gap-3" data-id="element-247" data-mp="14b8bq8vnfe96">
                  <span className="font-display text-7xl leading-none text-amber sm:text-8xl" data-id="element-248" data-mp="21wcn3475qs2g">
                    {PRICE}
                  </span>
                  <span className="font-display text-2xl leading-none text-cream-muted line-through" data-id="element-249" data-mp="1s6t3txfj8w72">
                    {TOTAL_VALUE}
                  </span>
                </p>
                <p className="mt-4 inline-block rounded-full bg-wine px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.08em] text-cream" data-id="element-250" data-mp="1n65edg6ycney">
                  You save {SAVINGS} &mdash; 96% discount
                </p>
                <p className="mt-3 text-[11px] uppercase tracking-label text-cream-muted" data-id="element-251" data-mp="2o5ktuxze9y5x">
                  One-time payment &middot; Lifetime access
                </p>

                <div className="mt-7" data-id="element-252" data-mp="2s8zb1rz2kkky">
                  <CtaButton size="lg" fullWidth data-id="element-253" data-mp="2x5g5t50rxx70">
                    Yes, I want the Arsenal
                  </CtaButton>
                </div>

                <p className="mt-3 text-xs font-semibold text-amber-light" data-id="element-254" data-mp="326drhrkzt9d9">
                  {PRICE} while the timer lasts &mdash; then the price returns to {REGULAR_PRICE}.
                </p>
                <p className="mt-3 text-xs text-cream-muted" data-id="element-255" data-mp="3b3xsr0iuv5nv">
                  Covered by our 10-day money-back guarantee.
                </p>
                <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-2 border-t border-night-600 pt-4" data-id="element-256" data-mp="3kvajtpwtxrsu">
                  <span className="flex items-center gap-2 text-[11px] text-cream-muted" data-id="element-257" data-mp="3pvg60qkbym3j">
                    <LockIcon className="h-3.5 w-3.5 text-amber" aria-hidden="true" data-id="element-258" data-mp="3ut88geilpqlz" />
                    Secure payment
                  </span>
                  <span className="flex items-center gap-2 text-[11px] text-cream-muted" data-id="element-259" data-mp="355vr3tlcvreq">
                    <ZapIcon className="h-3.5 w-3.5 text-amber" aria-hidden="true" data-id="element-260" data-mp="3082n977iz9hm" />
                    Instant access
                  </span>
                  <span className="flex items-center gap-2 text-[11px] text-cream-muted" data-id="element-261" data-mp="3a4p2ngh318c9">
                    <CreditCardIcon className="h-3.5 w-3.5 text-amber" aria-hidden="true" data-id="element-262" data-mp="3nw3odv2djnn0" />
                    Card &middot; Google Pay &middot; Apple Pay
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}